import React from "react";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";

interface DeleteButtonProps {
    id : number,
    isConfirmed : boolean,
    onDelete : (res : boolean) => void;
    onLoad : (res : boolean) => void;
    endPoint : string
}

const DeleteButton : React.FC<DeleteButtonProps> = ({id, isConfirmed, onDelete, onLoad, endPoint}) =>{

    function deleteClient(){
        if(!isConfirmed) return false;
        onLoad(true);

        setTimeout(async()=>{
            try{
                await api.delete(endPoint+id, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                });
                onDelete(true);
                onLoad(false);
            }catch(e){
                onDelete(false);
                onLoad(false)
            }
        },500)
    }

    return(
        <>
            <button type="button" onClick={deleteClient} className={isConfirmed ? "button button-danger" : "button button-disabled hover:cursor-not-allowed"}>
                Delete
            </button>
        </>
    );
}

export default DeleteButton;